import React, { useEffect, useState, useRef, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation, useHistory } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ListPaymentsOperator from "../../Components/ListPaymentsOperator";
import ListPagamentiRecenti from "../../Components/ListPagamentiRecenti";
import Select from "../../Components/Select";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListPaymemtsStatus(props) {
  const apiToken = useContext(TokenContext);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    name: null,
    chkNoSendMail: null,
    announcementId: null,
    fiscalcode: null,
  });
  const [nomeBando, setNomeBando] = useState("");
  const [statistiche, setStatistiche] = useState({});
  const [announcementId, setAnnouncementId] = useState("");
  const [announcementOptions, setAnnouncementOptions] = useState([]);
  const [recentPayments, setRecentPayments] = useState([]);
  const [giorni, setGiorni] = useState(7);

  const query = useQuery();
  const history = useHistory();
  const location = useLocation();

  const getTabFromQuery = (query) => {
    const tab = query.get("tab");
    return tab === "recent" ? "recent" : "search";
  };

  const [activeTab, setActiveTab] = useState(() => getTabFromQuery(query));

  useEffect(() => {
    setActiveTab(getTabFromQuery(query));
  }, [query]);

  const changeTab = (tab) => {
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);

    history.replace({
      search: params.toString(),
    });
  };

  useEffect(() => {
    if (activeTab !== "recent" || !apiToken) return;

    setLoading(false);

    Repo.getPagamentiRecenti(apiToken, giorni)
      .then((res) => {
        setRecentPayments(res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(true));
  }, [activeTab, giorni, apiToken]);

  useEffect(() => {
    console.log("getListPaymentFilterOperator");
    setLoading(false);
    if (apiToken) {
      Repo.getListPaymentFilterOperator(apiToken, filter)
        .then((response) => {
          if (response.status == 200) {
            setLoading(true);

            setPaymentsTemp(response.data);
          }
        })
        .catch((error) => {
          setLoading(true);
          console.log(error);
        });
      console.log("Leggo totali:");
      Repo.getTotali(apiToken)
        .then((response) => {
          if (response.status == 200) {
            setStatistiche(response.data);
          }
        })
        .catch((error) => {
          setLoading(true);
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(false); // Inizia il caricamento
      try {
        const response = await Repo.getAnnouncementsOperator(apiToken);
        if (response.status === 200) {
          const options = response.data.map((announcement) => ({
            value: announcement.id,
            label: announcement.name,
          }));
          console.log("Opzioni Annunci: ", options); // Aggiungi log per verificare
          setAnnouncementOptions(options);
        } else {
          throw new Error("Errore nel recupero dei dati"); // Gestisci errori di stato
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(true); // Termina il caricamento
      }
    };

    fetchAnnouncements();
  }, [apiToken]);

  const handleChange = (selectedOption) => {
    // Aggiorna solo l'announcementId nel filtro
    setFilter((prevFilter) => ({
      ...prevFilter,
      announcementId: selectedOption ? selectedOption.value : null,
    }));

    setNomeBando(selectedOption.label);
  };

  const sendFilter = () => {
    setLoading(false);
    console.log("Filtro da inviare:", filter); // Log del filtro
    Repo.getListPaymentFilterOperator(apiToken, filter)
      .then((response) => {
        setPaymentsTemp(response.data);
        console.log("Pagamenti: ", response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const checkStatus = async () => {
    try {
      const response = await Repo.getImportStato(apiToken);
      console.log(response.data);
      setIsUpdating(response.data.isUpdating);
    } catch (e) {
      console.log(e);
    }
  };

  const ricalcolaPosizioniDebitorie = () => {
    if (
      window.confirm(
        "Sei sicuro di voler procedere con il ricalcolo delle posizioni debitorie?",
      )
    ) {
      Repo.postRiceviPosizioniDebitorie(apiToken)
        .then((response) => {
          setIsUpdating(true);
          checkStatus();
          console.log("Operazione eseguita con successo", response);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log("Operazione annullata");
    }
  };

  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (!apiToken) return;

    checkStatus(); // prima lettura

    const interval = setInterval(() => {
      checkStatus();
    }, 10000);

    return () => clearInterval(interval);
  }, [apiToken]);

  return (
    <>
      <h1>Lista pagamenti</h1>
      <ul className="nav nav-tabs mt-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "search" ? "active" : ""}`}
            onClick={() => changeTab("search")}
          >
            Ricerca pagamenti
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "recent" ? "active" : ""}`}
            onClick={() => changeTab("recent")}
          >
            Pagamenti recenti
          </button>
        </li>
      </ul>
      {activeTab === "search" && (
        <>
          <div className="row">
            <div className="clearfix col-lg-8 py-lg-2">
              <p>
                Tutti i pagamenti ancora non effettuati o non ancora registrati
                sul sistema
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-7">
              {/*Inizo cerca*/}
              <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
                <h4>Filtra Pagamenti</h4>
                <div className="row">
                  <div className="form-group col-5">
                    <Input
                      id="name"
                      required
                      label="Ricerca nel titolo"
                      type="text"
                      name="name"
                      onChange={(e) =>
                        setFilter({ ...filter, name: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group col-4">
                    <div className="form-check">
                      <input
                        id="chkNoSendMail"
                        type="checkbox"
                        checked={filter.chkNoSendMail}
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            chkNoSendMail: e.target.checked,
                          })
                        }
                      />
                      <label htmlFor="chkNoSendMail">Email non inviata</label>
                    </div>
                  </div>

                  <div className="form-group col-3">
                    <Input
                      id="anno"
                      label="Anno"
                      type="number"
                      name="anno"
                      onChange={(e) =>
                        setFilter({ ...filter, anno: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-4">
                    <Input
                      id="fiscalcode"
                      label="Codice fiscale"
                      type="text"
                      name="fiscalcode"
                      onChange={(e) =>
                        setFilter({ ...filter, fiscalcode: e.target.value })
                      }
                    />
                  </div>
                  <div className="form-group col-8">
                    <Select
                      aria-label="Record"
                      defaultMenuIsOpen={false}
                      required
                      icon={false}
                      label="Ciao"
                      name="announcementsSelect"
                      id="announcementsSelect"
                      options={announcementOptions}
                      onChange={handleChange}
                      value={
                        announcementOptions.find(
                          (option) => option.value === filter.announcementId,
                        ) || null
                      } // Verifica se esiste
                      placeholder="Seleziona un bando"
                    />
                  </div>

                  <div className="form-group col-12 text-right">
                    <button
                      type="button"
                      className="btn btn-outline-secondary m-2"
                    >
                      Annulla
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={sendFilter}
                    >
                      Cerca
                    </button>
                  </div>
                </div>
              </div>
              {/*Fine cerca*/}
            </div>

            <div className="col-5">
              <div className="callout">
                <div className="callout-inner">
                  <div className="callout-title">
                    <svg className="icon">
                      <use href={`${iconSprite}#it-info-circle`} />
                    </svg>

                    <span className="text">Statistiche Pagamenti</span>
                  </div>
                  <div>
                    <p className="mb-1">Riepilogo:</p>

                    <ul className="space-y-1">
                      {Object.entries(statistiche).map(([nome, valore]) => (
                        <li
                          key={nome}
                          className="flex justify-between border-b pb-1"
                        >
                          <span>{nome}: </span>
                          <strong>{valore?.toFixed(2)} €</strong>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="d-grid text-right">
                    <button
                      type="button"
                      className="btn btn-success m-2"
                      onClick={ricalcolaPosizioniDebitorie}
                      disabled={isUpdating} // Disabilita il pulsante mentre l'importazione è in corso
                    >
                      {isUpdating ? (
                        <>Importazione in corso...</>
                      ) : (
                        <>Sincronizza</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*Inizo cerca*/}

          {paymentsTemp && paymentsTemp.length > 0 ? (
            <ListPaymentsOperator
              payments={payments}
              paymentsTemp={paymentsTemp}
              setPayments={setPayments}
              fiscalCode={true}
              goBack={true}
              nomeBando={nomeBando}
              filter={filter}
            />
          ) : (
            <>
              <div className="alert alert-warning" role="alert">
                <strong>Attenzione! </strong> Non ci sono pagamenti!
              </div>
            </>
          )}
        </>
      )}
      {activeTab === "recent" && (
        <>
          <div className="row align-items-end">
            <div className="col-6 mt-3">
              <p>
                Tutti i pagamenti registrati negli ultimi giorni selezionati.
              </p>
            </div>
            <div className="col-6 mt-3">
              <span>Ultimi giorni:</span>
              <Input
                type="number"
                value={giorni?.toString() ?? ""}
                onChange={(e) => setGiorni(Number(e.target.value))}
              />
            </div>
          </div>
          <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
            {recentPayments?.length > 0 ? (
              <ListPagamentiRecenti items={recentPayments} />
            ) : (
              <div className="alert alert-warning">
                Nessun pagamento recente
              </div>
            )}
          </div>
        </>
      )}

      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListPaymemtsStatus;
